import React from "react";

import { SidebarWrapper, Header } from "@common/styled/sidebar";
import { Text } from "ui-components";
import { DescriptionWrapper } from "./styled";

class Sidebar extends React.Component {
  render() {
    return (
      <SidebarWrapper>
        <Header>
          <Text type="medium" size="3">
            Community Care Violence Assessment Tool
          </Text>
        </Header>
        <DescriptionWrapper>
          <Text paddingV="1" type="medium" size="4">
            Pre-Visit Assessment
          </Text>
          <Text paddingV="1" type="medium" size="5">
            Description:
          </Text>
          <Text paddingV="1" type="light" size="5">
            Use the following pre-visit assessment tool as a guide for interviewing the client and/or family member(s) of the client. Read through each assessment item and answer the question with a ‘yes’ or ‘no’. A ‘yes’ response indicates an elevated risk and an appropriate control measure should be considered.
          </Text>
          <Text paddingV="1" type="light" size="5">
            Share the completed form with workers and clearly communicate risk factors and precautions to be taken.
          </Text>
        </DescriptionWrapper>
      </SidebarWrapper>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/previsit/components/Sidebar/Sidebar.jsx